<template>
  <nav class="nav-bar">
    <router-link to="/finance" class="nav-bar__link" active-class="active">
      <div class="nav-bar__link-image">
        <img
          src="@/assets/images/finance_icon.svg"
          alt="Finance Icon"
          class="hide-mobile hide-tablet"
        />
      </div>
      <p class="nav-bar__link-text">{{ $t("my finances") }}</p>
    </router-link>
    <router-link to="/instruction" class="nav-bar__link" active-class="active">
      <div class="nav-bar__link-image">
        <img
          src="@/assets/images/instruction_icon.svg"
          alt="Finance Icon"
          class="hide-mobile hide-tablet"
        />
      </div>
      <p class="nav-bar__link-text">{{ $t("errands") }}</p>
    </router-link>
    <router-link to="/stock" class="nav-bar__link" active-class="active">
      <div class="nav-bar__link-image">
        <img
          src="@/assets/images/stock_icon.svg"
          alt="Finance Icon"
          class="hide-mobile hide-tablet"
        />
      </div>
      <p class="nav-bar__link-text">{{ $t("instruments") }}</p>
    </router-link>
    <router-link to="/report" class="nav-bar__link" active-class="active">
      <div class="nav-bar__link-image">
        <img
          src="@/assets/images/report_icon.svg"
          alt="Finance Icon"
          class="hide-mobile hide-tablet"
        />
      </div>
      <p class="nav-bar__link-text">{{ $t("reports") }}</p>
    </router-link>
    <!-- <router-link to="/contact" class="side-bar__link" active-class="active">
      <div class="side-bar__link-image">
        <img src="@/assets/images/contact_icon.svg" alt="Finance Icon" />
      </div>
      <p class="side-bar__link-text">{{ $t("contacts") }}</p>
    </router-link> -->
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.nav-bar {
  min-height: 90vh;
  background-color: #2f3a57;
}

.nav-bar__link {
  height: 86px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  box-sizing: border-box;
}

.nav-bar__link.active {
  background-color: #222c44;
}

.nav-bar__link-text {
  text-align: center;
  font-size: 12px;
  color: #ffffff;
}

@media all and (max-width: 1100px) {
  .nav-bar__link-text {
    font-size: 10px;
  }
}

@media all and (max-width: 950px) {
  .nav-bar__link-text {
    font-size: 8px;
  }
}
@media (max-width: 1300px) {
  .nav-bar__link-text {
    font-size: 10px;
    padding: 0 5px;
  }
}
@media (max-width: 1100px) {
  .nav-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    min-height: auto;
    height: 10vh;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    z-index: 10;
    background-color: #f8f8f8;
  }

  .nav-bar__link {
    height: auto;
    padding: 10px;
    justify-content: center;
    border-radius: 50%;
    background-color: transparent;
  }

  .nav-bar__link.active {
    background-color: transparent;
  }

  .nav-bar__link-image {
    height: 5vh;
    width: 5vh;
    background-color: #acb5c5;
    border-radius: 50%;
  }

  .nav-bar__link-text {
    margin-top: 5px;
    font-size: 10px;
    color: #000000;
  }
}

@media (max-width: 600px) {
  .nav-bar__link-image {
    height: 4vh;
    width: 4vh;
  }
}
</style>
